import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import React from "react";
import { useLanguage } from "../LanguageContext";
import { Helmet } from "react-helmet-async";
import parse from "html-react-parser";

function ResearchPublications() {
  const API_URL = process.env.REACT_APP_API_URL;
  const IMG_BASE_URL = process.env.REACT_APP_API_BASE_URL_img;
  const { lang } = useLanguage();

  const [apiData, setApiData] = useState([]);
  const [PageData, setPageData] = useState(null);
  const [selectedYear, setSelectedYear] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { slug } = useParams();
  const navigate = useNavigate();

  const getPage = async () => {
    if (!slug) return;

    try {
      const res = await axios.get(`${API_URL}/pages/get/slug/${slug}`, {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });

      setPageData(res.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getData = async (apiName) => {
    const result = apiName.split("/").pop();

    try {
      const res = await axios.get(
        `${API_URL}/PublicationsRoutes/get/web/${result}`,
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        },
      );

      const activeData = (res.data?.data || []).filter(
        (item) => item.isActive === true,
      );

      setApiData(activeData);
      //   latest year find
      const latestYear = Math.max(...activeData.map((item) => item.year));
      setSelectedYear(String(latestYear));
      const defaultFiltered = activeData.filter(
        (item) => item.year === latestYear,
      );

      setFilteredData(defaultFiltered);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getPage();
  }, [slug]);

  useEffect(() => {
    if (PageData?.apiName) {
      getData(PageData?.apiName);
    }
  }, [PageData?.apiName]);

  const handleFilter = () => {
    if (!selectedYear) {
      setFilteredData(apiData);
      return;
    }

    const filtered = apiData.filter(
      (item) => String(item.year) === String(selectedYear),
    );

    setFilteredData(filtered);
  };

  const allowedPages = [
    "Annual Report",
    "Newsletters",
    "Hindi Patrika",
    "Others",
  ];
  // const handleDownload = async (e, fileUrl, fileName) => {
  //   e.stopPropagation();

  //   try {
  //     const response = await fetch(fileUrl);

  //     if (!response.ok) {
  //       throw new Error("File not found");
  //     }

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = fileName || "download";

  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //     alert("File download failed");
  //   }
  // };

  const handleDownload = async (e, fileUrl, fileName) => {
    e.stopPropagation();
    setLoading(true);
    try {
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error("File not found");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
      alert("File download failed");
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = async (year, category) => {
    try {
      const res = await axios.get(
        `${API_URL}/pages/get/web/6a2a90589f1cfc2feddfaef0`,
      );

      const slug = res?.data?.data?.slug;
      if (slug) {
        navigate(`/${slug}/${category}/${year}`);
      }
    } catch (error) {
      console.error("Error fetching page slug:", error);
    }
  };

  // console.log("apiData",apiData);
  
  return (
    <div className="main-wrapper">
      {loading && (
        <div className="loader-overlay">
          <div className="spinner"></div>
          <p>Downloading...</p>
        </div>
      )}
      {/* ================= SEO START ================= */}
      <Helmet>
        <title>{PageData?.pageTitle?.[lang] || "Technical Staff"}</title>

        <meta
          name="description"
          content={PageData?.metaDescription?.[lang] || ""}
        />

        <meta name="keywords" content={PageData?.keyWord?.[lang] || ""} />

        <meta property="og:title" content={PageData?.pageTitle?.[lang]} />
        <meta
          property="og:description"
          content={PageData?.metaDescription?.[lang]}
        />
        <meta
          property="og:image"
          content={`${IMG_BASE_URL}/${PageData?.photo}`}
        />
      </Helmet>
      {/* ================= SEO END ================= */}

      <section
        className="banner-section position-relative"
        style={{
          backgroundImage: `url(${IMG_BASE_URL}/${PageData?.photo})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="banner-title z_index1">
                <h1 className="banner-slider-title fw-500 text-white">
                  {PageData?.pageTitle?.[lang]}
                </h1>
                <ul className="breadcrumb-area m-0 p-0">
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li>
                    <i className="fa-solid fa-angle-right"></i>
                  </li>
                  <li className="breadcrumb-title">
                    {PageData?.pageTitle?.[lang]}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {apiData?.[0]?.category !== "Forms" &&
        apiData?.[0]?.category !== "Newsletters"  &&
        apiData?.[0]?.category !== "HindiPatrika"  &&
        apiData?.[0]?.category !== "AnnualReport" && (
          <section className="institute-section position-relative overflow-hidden section-padding">
            <div className="container position-relative z_index1">
              <div className="row common-space row-gap institute-row">
                {apiData?.[0]?.category !== "Forms" &&
                  apiData?.[0]?.category !== "AnnualReport" &&
                  [...new Set(apiData?.map((item) => item.year))]
                    ?.sort((a, b) => b - a)
                    ?.map((year, index) => {
                      return (
                        <div
                          key={index}
                          onClick={() =>
                            handlePageClick(year, apiData?.[0]?.category)
                          }
                          className="col-sm-6 col-lg-3 institute-col"
                        >
                          <div className="institute-box text-center h-100 slow-effect hover-effect">
                            <p className="institute-title fs-30 fw-500 d-block">
                              {year}
                            </p>

                            <a
                              href="#"
                              className="common-btn btn-style-one mx-auto"
                            >
                              <span className="btn-static-text">
                                {lang === "hi" ? "देखें" : "Explore"}
                              </span>
                              <span className="btn-arrow">
                                <i className="fa-solid fa-arrow-right-long"></i>
                              </span>
                            </a>
                          </div>
                        </div>
                      );
                    })}
              </div>
            </div>
            {/* <div className="institute-bottom-shape">
            <img src="images/shape/shape2_left.png" alt="" />
          </div> */}
          </section>
        )}
      {(apiData?.[0]?.category === "AnnualReport" 
      || apiData?.[0]?.category === "HindiPatrika" 
      || apiData?.[0]?.category === "Newsletters" )&& (
        <>
          <section className="institute-section position-relative overflow-hidden section-padding">
            <div className="container position-relative z_index1">
              <div className="row common-space row-gap institute-row">
                {apiData?.map((item, index) => {
                  const fileUrl = item?.file
                    ? `${IMG_BASE_URL}/files/${item?.file}`
                    : null;

                  return (
                    <>
                      <div
                        key={index}
                        className="col-sm-6 col-lg-4 col-xl-3 staff-col"
                      >
                        <div className="team-item slow-effect h-100">
                          <div className="team-image position-relative overflow-hidden">
                            <figure className="figure-box m-0">
                              <img
                                className="slow-effect"
                                src={`${IMG_BASE_URL}/files/${item?.image}`}
                                alt=""
                              />
                            </figure>
                          </div>
                          <div className="team-body">
                            <div className="team-content">
                              <div
                                className="download-btn d-flex justify-content-center align-items-center"
                                style={{ width: "100%" }}
                              > 
                                <h3
                                  className="team-member-name fs-20 fw-600"
                                  style={{ cursor: "pointer" }}
                                  dangerouslySetInnerHTML={{
                                    __html: item?.title?.[lang],
                                  }}
                                ></h3>
                              </div>
                              <div
                                className="download-btn d-flex justify-content-center align-items-center"
                                style={{ width: "100%" }}
                              >
                                <button
                                  onClick={(e) =>
                                    handleDownload(e, fileUrl, item.file)
                                  }
                                  style={{
                                    // marginTop: "8px",
                                    padding: "6px 12px",
                                    border: "none",
                                    // background: "#007bff",
                                    color: "white",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                  className="theme-bg"
                                >
                                  Download File
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </section>
        </>
      )}
      {/* .list-details .fa-circle-check */}
      <section className="institution-section body-shape section-padding">
        <div className="container">
          <div className="row row-gap">
            <div className="col-12">
              {apiData?.[0]?.category === "Forms" &&
                apiData?.map((item, index) => {
                  const fileUrl = item?.file
                    ? `${IMG_BASE_URL}/files/${item.file}`
                    : null;

                  return (
                    <div
                      key={item?.id || index}
                      style={{
                        padding: "1vw",
                        backgroundColor:
                          index % 2 === 0 ? "#f2f2f2" : "#ffffff",
                        color: "black",
                      }}
                    >
                      <div className="list-details listing-download-list">
                        <div className="list-data">
                          <div className="sr-number">
                            <i className="fa-solid fa-circle-check fs-22"></i>
                          </div>

                          <p
                            className="title-name m-0 fw-600 fs-16 slow-effect"
                            dangerouslySetInnerHTML={{
                              __html: item?.title?.[lang],
                            }}
                          />
                        </div>

                        <div className="download-btn md-ms-auto">
                          {fileUrl && (
                            <button
                              onClick={(e) =>
                                handleDownload(e, fileUrl, item.file)
                              }
                              style={{
                                marginTop: "8px",
                                padding: "6px 12px",
                                border: "none",
                                color: "white",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              className="theme-bg"
                            >
                              Download File
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ResearchPublications;
